// reducers/doctorReducer.js
import { createSlice } from '@reduxjs/toolkit';

const templateSlice = createSlice({
  name: 'template',
  initialState: {
    templateList: [],
    whatsappTemplateList: [],
    totalNumberOfTemplate: 0,
    selectedTemplate: {},
    filterTemplateParam: {
      speciality_id: '',
      search: '',
      current_page: 1,
      limit: 20,
    },
  },
  reducers: {
    setTemplateList: (state, action) => {
      state.templateList = action.payload;
    },
    setWhatsappTemplateList: (state, action) => {
      state.templateList = action.payload;
    },
    updateFilterTemplateParam: (state, action) => {
      state.filterTemplateParam = action.payload;
    },
    updateSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    setTotalNumberOfTemplate: (state, action) => {
      state.totalNumberOfTemplate = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.filterTemplateParam.current_page = action.payload;
    },
  },
});

export const {
  setTemplateList,
  updateFilterTemplateParam,
  updateSelectedTemplate,
  setCurrentPage,
  setTotalNumberOfTemplate,
  setWhatsappTemplateList,
} = templateSlice.actions;

export default templateSlice.reducer;
